<template>
  <div>
    <b-overlay
      variant="white"
      :show="displayOverlay"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card title="Clientes">
        <b-button
          v-if="canDisplaySyncButton"
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          v-b-modal.sync-user-modal
        ><feather-icon icon="RefreshCwIcon" /> Sincronizar</b-button>
        <b-button
          v-if="canDisplayButton"
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          v-b-modal.expired-user-modal
        ><feather-icon icon="AlertOctagonIcon" /> Clientes expirados</b-button>
        <b-button
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          @click="reportData"
        >
          <feather-icon icon="FileTextIcon" />
          Exportar
        </b-button>
        <b-button
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          v-b-modal.consulting-rights-modal
        >
          <feather-icon icon="SearchIcon" />
          Direitos
        </b-button>
        <b-button
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          @click="openAdvancedFilters"
        >
          <feather-icon icon="SearchIcon" />
          Filtros
        </b-button>
        <manage-clients-filter
          v-if="displayFilter"
          :totalRows="totalRows"
          class="filters"
          @updateData="updateFilters"
        ></manage-clients-filter>
        <custom-g-table
          v-if="displayTable"
          :displayLoading="tableLoading"
          :fields="fields"
          :items="data"
          :hasEditButton="canDisplayButton"
          :totalRows="totalRows"
          :limit="limit"
          @changePage="onChangePage"
          @onEdit="onEdit"
          @onSortChange="onSortChange"
          @onColumnFilter="onFilter"
        />
      </b-card>
    </b-overlay>
    <b-modal
      ref="sync-user-modal"
      id="sync-user-modal"
      modal-class="modal-primary"
      title="Sincronização de usuário"
      ok-title="Adicionar"
      centered
      no-close-on-backdrop
    >
      <div class="d-block">
        <b-row>
          <b-col md="12">
            <label for="sync-params-login">Login</label>
            <b-form-input
              id="sync-params-login"
              v-model="syncParamsForm.login"
            />
          </b-col>
          <b-col md="12">
            <label for="sync-params-logical-number">Numero Logico</label>
            <v-select
              id="sync-params-logical-number"
              placeholder="Selecione um numero logico"
              v-model="syncParamsForm.logicalNumber"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="logicalNumber"
              :tabindex="0"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-col>
          <!-- <b-col md="12">
            <label for="sync-params-logical-number">Origem</label>
            <v-select
              id="sync-params-logical-number"
              placeholder="Selecione um numero logico"
              v-model="syncParamsForm.origin"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="origins"
              :tabindex="0"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-col> -->
          <b-col md="12">
            <label for="sync-params-data">Data</label>
            <flat-pickr
              id="sync-params-data"
              v-model="syncParamsForm.data"
              class="form-control input-dt-schedule"
              :config="{
                enableTime: false,
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd/m/Y',
                allowInput: true,
                inline: false,
              }"
            />
          </b-col>
          <b-col md="12" class="mt-2">
            <small>Apenas selecione caso realize sincronização completa (sem preencher campos acima)</small>
            <b-form-checkbox
              class="mb-1"
              id="disableClients"
              name="disableClients"
              v-model="syncParamsForm.disableClients"
            >
              Desabilitar clientes
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-button
            class="btn-sm btn-nav-link btn-nav-link-white"
            size="sm"
            variant="flat-primary"
            :disabled="isSyncing"
            @click="onSync"
          >
            <feather-icon v-if="!isSyncing" icon="RefreshCwIcon" />
            <b-spinner v-if="isSyncing" small />
            {{ isSyncing ? "Sincronizando..." : "Sincronizar" }}
          </b-button>
        </b-row>        
      </div>
    </b-modal>
    <b-modal
      ref="expired-user-modal"
      id="expired-user-modal"
      modal-class="modal-primary"
      title="Usuários Expirados"
      ok-title="Adicionar"
      centered
      no-close-on-backdrop
    >
      <div class="d-block">
        <b-row>
          <b-col md="12">
            <label for="sync-params-logical-number">Origem</label>
            <v-select
              id="sync-params-logical-number"
              placeholder="Selecione um numero logico"
              v-model="syncParamsForm.origin"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="origins"
              :tabindex="0"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col md="12">
            <b-button
              class="btn-sm btn-nav-link btn-nav-link-white"
              size="sm"
              variant="flat-primary"
              @click="checkExpiredClients"
            >
              Buscar
            </b-button>
            <b-button
              class="btn-sm btn-nav-link btn-nav-link-white"
              size="sm"
              variant="flat-danger"
              @click="trasnformExpiredClientsToFree"
            >
              Expirados para gratuito
            </b-button>
          </b-col>
        </b-row>        
        <hr>
        <b-row>
          <b-col md="12">
            Total de clientes expirados: {{expiredClients.length}}
          </b-col>
          <b-col md="12">
            Emails expirados: {{expiredClients}}
          </b-col>
        </b-row>
      </div>
    </b-modal>
      <b-modal
        ref="consulting-rights-modal"
        id="consulting-rights-modal"
        modal-class="modal-primary consulting-rights-modal "
        title="Consultar direitos"
        ok-title="Adicionar"
        centered
        size="xl"
        no-close-on-backdrop
      >
        <div class="d-block">
          <consulting-client-rights></consulting-client-rights>
        </div>
      </b-modal>
  </div>
  
</template>

<script>
import { BCard, BButton, VBModal, BRow, BCol, BFormInput, BSpinner, BOverlay, BFormCheckbox } from "bootstrap-vue";
import vSelect from "vue-select";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import clientService from "@/providers/clientService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import dropdownService from "@/providers/dropdownService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import flatPickr from "vue-flatpickr-component";
// import { isBoolean } from '@vueuse/shared';
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import ConsultingClientRights from './ConsultingClientRights.vue'
import ManageClientsFilter from './ManageClientsFilter.vue';
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object,
    filterData: {
      type: Object,
    },
  },
  components: {
    flatPickr,
    BCard,
    BButton,
    CustomGTable,
    BRow, BCol, BFormInput, BSpinner,
    vSelect,
    // CustomFilter,
    ConsultingClientRights,
    ManageClientsFilter,
    BOverlay,
    BFormCheckbox
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      filters: {},
      displayTable: false,
      displayFilter: false,
      displayOverlay: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      tableLoading: true,
      fields: [
        { 
          field: "action_buttons", 
          label: "Ações", 
          sortable: false 
        },
        {
          field: "email",
          label: "Email",
          sortable: true,
        },
        {
          field: "name",
          label: "Nome",
          sortable: true,
        },
        { 
          field: "system_prop", 
          label: "Perfil", 
          type: "array", 
          object_field: "profile", 
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "Usuário logico", 
          type: "array", 
          object_field: "logical_user", 
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "País", 
          type: "array", 
          object_field: "country", 
          object_in_object_field: "name", 
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "Número Lógico", 
          type: "array", 
          object_field: "logicalNumber", 
          object_in_object_field: "name", 
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "Origem do cadastro", 
          type: "array", 
          object_field: "originsCode", 
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "Origem do sistema", 
          type: "array", 
          object_field: "origin", 
          object_in_object_field: "name", 
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "Pacote contratado", 
          type: "array", 
          object_field: "signature", 
          object_in_object_field: "namePtBr",
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "Data Criação", 
          type: "array", 
          object_field: "dt_create", 
          object_field_type: "custom_date", 
          sortable: true,
        },
        { 
          field: "system_prop", 
          label: "Data Atualização", 
          type: "array", 
          object_field: "dt_update", 
          object_field_type: "custom_date", 
          sortable: true,
        },
        { 
          field: "system_prop", 
          label: "Siga Login Inicio", 
          type: "array", 
          object_field: "siga_login_inicio", 
          object_field_type: "custom_date", 
          sortable: false,
        },
        { 
          field: "system_prop", 
          label: "Siga Login Termino", 
          type: "array", 
          object_field: "siga_login_termino", 
          object_field_type: "custom_date", 
          sortable: false, 
        },
        { 
          field: "system_prop", 
          label: "Habilitado", 
          type: "array", 
          object_field: "active", 
          object_field_type: "boolean", 
          sortable: false,
        },
        { 
          field: "wantDeleteAccount", 
          label: "Pedido de deleção", 
          type: "boolean", 
          object_field: "active", 
          object_field_type: "boolean", 
          sortable: false,
        },
      ],
      origins: [],
      logicalNumber: [],
      isSyncing: false,
      syncParamsForm: {
        logicalNumber: null,
        login: '',
        data: '',
        origin: null,
        disableClients: false
      },
      expiredClients: []
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", 'Clientes');
    this.loadDataFilter();
  },
  computed: {
    userData() {
      return this.$store.state.auth.currentUser || {};
    },
    canDisplayButton() {
      return this.userData.profile == AppConstants.USER_PROFILE.ADMIN || this.userData.profile == AppConstants.USER_PROFILE.ATTENDANCE || this.userData.profile == AppConstants.USER_PROFILE.CONTRACT || this.userData.profile == AppConstants.USER_PROFILE.MARKETING;
    },
    canDisplaySyncButton() {
      return this.userData.profile == AppConstants.USER_PROFILE.ADMIN || this.userData.profile == AppConstants.USER_PROFILE.CONTRACT;
    },
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.filters.name) {
        params.append('name', this.filters.name);
      }
      if (this.filters.email) {
        params.append('email', this.filters.email);
      }
      if (this.filters.profile) {
        params.append('profile', this.filters.profile);
      }
      if (this.filters.logicalUser) {
        params.append('logical_user', this.filters.logicalUser);
      }
      if (this.filters.country) {
        params.append('country', this.filters.country);
      }
      if (this.filters.logicalNumber) {
        params.append('logicalNumber', this.filters.logicalNumber);
      }
      if (this.filters.registerSystemFrom) {
        params.append('register_system_from', this.filters.registerSystemFrom);
      }
      if (this.filters.origin) {
        params.append('origin', this.filters.origin);
      }
      if (this.filters.signature) {
        params.append('signature', this.filters.signature);
      }
      if (this.filters.dtCreate) {
        params.append('dt_create', this.filters.dtCreate);
      }
      if (this.filters.dtUpdate) {
        params.append('dt_update', this.filters.dtUpdate);
      }
      if (this.filters.sigaLoginInicio) {
        params.append('siga_login_inicio', this.filters.sigaLoginInicio);
      }
      if (this.filters.sigaLoginTermino) {
        params.append('siga_login_termino', this.filters.sigaLoginTermino);
      }
      if (this.filters.active) {
        params.append('active', this.filters.active);
      }

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    updateFilters(object) {
      this.filters = object;
      // this.onFilter(this.filters);
      this.loadData();
    },
    openAdvancedFilters() {
      this.displayFilter = !this.displayFilter;
    },
    trasnformExpiredClientsToFree() {
      messageDialogHelper.displayConfirmMessage(
        "Gratuito",
        "Gostaria de transformar todos os usuários expirados para gratuito?",
        () => {
          const params = new URLSearchParams();
          if (this.syncParamsForm.origin) {
            params.append('originCode', this.syncParamsForm.origin.code);
          }
          clientService
            .trasnformExpiredClientsToFree(params)
            .then(() => {
              this.$refs['expired-user-modal'].hide();
              messagesNotifyHelper.successNotify(
                "Gratuito",
                "Clientes transformado para gratuito feito com sucesso!"
              );

              this.loadData();
            })
            .catch((err) => {
              this.isSyncing = false;
              console.log(err);
            });
        }
      );
    },
    checkExpiredClients() {
      const params = new URLSearchParams();
      if (this.syncParamsForm.origin) {
        params.append('originCode', this.syncParamsForm.origin.code);
      }
      clientService
        .getExpiredClients(params)
        .then((response) => {
          this.expiredClients = response;
        })
        .catch((err) => {
          this.isSyncing = false;
          console.log(err);
        });
    },
    setInitialTableFilters() {
      // Object.keys(this.urlQuery).forEach(item => {
      //   this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      // // this.objectFilters[item] = this.urlQuery[item];
      // });
      this.loadData();
    },
    onSync() {
      console.log(this.syncParamsForm)
      this.isSyncing = true;
      messageDialogHelper.displayConfirmMessage(
        "Sincronização",
        "Gostaria de sincronizar os usuários com sigaweb?",
        () => {
          const params = new URLSearchParams();
          if (this.syncParamsForm.logicalNumber) {
            params.append('logicalNumber', this.syncParamsForm.logicalNumber.name);
          }
          if (this.syncParamsForm.login) {
            params.append('login', this.syncParamsForm.login);
          }
          if (this.syncParamsForm.data) {
            params.append('data', convertDatetimeHelper.convertStringToDateTimeSiga(this.syncParamsForm.data));
          }
          if (this.syncParamsForm.origin) {
            params.append('originCode', this.syncParamsForm.origin.code);
          }
          if (this.syncParamsForm.disableClients) {
            params.append('disableClients', this.syncParamsForm.disableClients);
          }
          clientService
            .sync(params)
            .then((response) => {
              this.isSyncing = false;
              console.log(response);
              this.$refs['sync-user-modal'].hide();
              messagesNotifyHelper.successNotify(
                "Sincronização Sigaweb",
                "Sincronização feita com sucesso"
              );

              this.loadData();
            })
            .catch((err) => {
              this.isSyncing = false;
              console.log(err);
            });
        }
      );
    },
    reportData() {
      this.displayOverlay = true;
      const params = this.searchParams;
      params.append("download", true);
      clientService
        .report(params)
        .then((response) => {
          this.displayOverlay = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "clientes.xlsx");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => {
          this.displayOverlay = false;
          console.log(err);
        });
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log('OnFilter: ', this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      const params = new URLSearchParams();
      params.append('sync_client_siga', true);
      Promise.all([
        dropdownService.getAllOrigin(params),
        dropdownService.getAllLogicalNumber(new URLSearchParams()),
      ])
        .then((resp) => {
          this.origins = resp[0].map(item => {
            item.name = `${item.name} - ${item.code}`
            return item;
          });
          if (this.origins.length == 1) {
            this.syncParamsForm.origin = this.origins[0];
          }
          this.logicalNumber = resp[1];
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_USER_CLIENT_REGISTER}/${data._id}`
      );
    },
    loadData() {
      this.tableLoading = true;
      this.displayOverlay = true;
      onlyLatestRequest(this, 'loadData', clientService.getAllClient(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          this.displayOverlay = false;
          // console.log(res);
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          this.tableLoading = false;
          this.displayOverlay = false;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>